package com.clany.backoffice.data.network

val API_URL_BASE: String get() = KeycloakConfig.API_URL
val AUTH_URL_BASE: String get() = KeycloakConfig.AUTH_URL
val CLIENT_ID: String get() = KeycloakConfig.CLIENT_ID
val REALM: String get() = KeycloakConfig.REALM

// Keycloak Endpoints
val LOGIN_URL: String get() = AUTH_URL_BASE.plus("/realms/$REALM/protocol/openid-connect/token")
val LOGOUT_URL: String get() = AUTH_URL_BASE.plus("/realms/$REALM/protocol/openid-connect/logout")
val KEYCLOAK_AUTH_URL: String get() = AUTH_URL_BASE.plus("/realms/$REALM/protocol/openid-connect/auth")
